export abstract class BaseClientConfig {

    protected skipFields: string[] = [];

    protected configKey: string;

    protected db: ConfigDatabase;

    constructor(configKey: string) {
        this.configKey = configKey;
        this.db = new ConfigDatabase(this.configKey);
    }

    public get ready(): Promise<this> {
        return new Promise<this>((resolve) => {
            this.loadConfig().then(() => resolve(this));
        });
    }

    async loadConfig() {
        // for (const [key, value] of Object.entries(JSON.parse(localStorage.frontAppConfig ?? '{}')))
        for (const [key, value] of Object.entries(await this.db.load()))
        {
            const item = { key, value };
            this.afterLoadItem(item);
            // @ts-ignore
            this[item.key] = item.value;
        };
    }

    async saveConfig() {
        // localStorage.frontAppConfig = JSON.stringify(this.getConfigData());
        await this.db.save(this.getConfigData());
    }

    getConfigData() {
        return Object.fromEntries(
            Object.getOwnPropertyNames(this)
                .filter(key => !this.skipFields.includes(key) && ![ 'configKey', 'db', 'skipFields' ].includes(key))
                .map(key => {
                    //@ts-ignore
                    const item = { key, value: this[key] }
                    this.beforeSaveItem(item);
                    return [ item.key, item.value ];
                }
            )
        );
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected beforeSaveItem(item: { value: any; key: string }) { }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected afterLoadItem(item: { value: any; key: string }) { }

    public async updateAndSaveConfig(values: Partial<typeof this>): Promise<void> {
        for (const [key, value] of Object.entries(values)) {
            // @ts-ignore
            this[key] = value;
        }
        this.saveConfig();
    }
}

export class ConfigDatabase {

    protected db: Promise<IDBDatabase>;
    protected storeName: string;
    protected configKey: string;

    constructor(
        configKey: string,
        storeName: string = 'config',
        dbName: string = 'config',
        dbVersion: number = 1,
    ) {
        if (!configKey) throw new Error('Config key must be defined');
        this.storeName = storeName;
        this.configKey = configKey;
        this.db = new Promise((resolve, reject) => {
            const request = indexedDB.open(dbName, dbVersion);

            request.onerror = (event) => {
                console.error('Error opening db:', event);
                reject(event);
            };

            request.onsuccess = () => {
                resolve(request.result);
            };

            request.onupgradeneeded = (event) => {
                const db = request.result;
                if (!db.objectStoreNames.contains(storeName)) {
                    db.createObjectStore(storeName);
                }
            };
        });
    }

    protected requestToPromise(request: IDBRequest): Promise<any>
    {
        return new Promise((resolve, reject) => {
            request.onsuccess = () => resolve(request.result || {});
            request.onerror = (event) => reject(event);
        });
    }

    public async save(data: Record<string, any>) {
        const transaction = (await this.db)
            .transaction(this.storeName, 'readwrite');
        const res = transaction
            .objectStore(this.storeName)
            .put(data, this.configKey);
        transaction.commit();

        return this.requestToPromise(res);
    }

    public async load(): Promise<Record<string, any>> {
        return this.requestToPromise(
            (await this.db)
                .transaction(this.storeName, 'readwrite')
                .objectStore(this.storeName)
                .get(this.configKey)
        );
    }
}
